import { LoadingHolder } from './styles'

const AnimatedLoader = ({ onlyWhite = false, size = 16 }) => (
  <LoadingHolder size={size}>
    <img
      src={`/loading-state${onlyWhite ? '-white' : '-black'}.svg`}
      alt="loading"
    />
  </LoadingHolder>
)

export default AnimatedLoader
